// extracted by mini-css-extract-plugin
export default {"flag":"Header_flag__d1pHP","blank":"Header_blank__qsErb","buttonText":"Header_buttonText__53RZW"};